import { API_FILE_PREFIX, API_FILE_NO_AUTH_PREFIX } from '@shared/config/api/api-prefixes';
import { fileBaseApi } from './base';
import {
    FileDetailDataResponse,
    FileDetailDataRequest,
    PrivateImageDataResponse,
    PrivateImageDataRequest,
} from './file-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { FilesListDataRequest, FilesListDataResponse } from '@shared/api/file/file-types';

export const fileApi = fileBaseApi.injectEndpoints({
    endpoints: (build) => ({
        filesList: build.query<FilesListDataResponse, FilesListDataRequest>({
            query: (parameters) => `${API_FILE_PREFIX}${queryParametersToString({ ...parameters })}`,
            providesTags: ['FilesList'],
        }),
        fileDetail: build.query<FileDetailDataResponse, FileDetailDataRequest>({
            query: (id) => `${API_FILE_PREFIX}/${id}/detail`,
            providesTags: ['FileDetail'],
        }),
        filesListNoAuth: build.query<FilesListDataResponse, FilesListDataRequest>({
            query: (parameters) => `${API_FILE_NO_AUTH_PREFIX}${queryParametersToString({ ...parameters })}`,
            providesTags: ['FilesListNoAuth'],
        }),
        privateImage: build.query<PrivateImageDataResponse, PrivateImageDataRequest>({
            query(fileId) {
                return {
                    url: `${API_FILE_PREFIX}/${fileId}/binary`,
                    method: 'GET',
                    responseHandler: async (response) => {
                        const blob = await response.blob();
                        const reader = new FileReader();
                        reader.readAsDataURL(blob);
                        const base64 = await new Promise((resolve) => {
                            reader.onloadend = () => {
                                resolve(reader.result);
                            };
                        });
                        return base64;
                    },
                    cache: 'no-cache',
                };
            },
        }),
    }),
});

export const { useLazyFilesListQuery, useLazyFileDetailQuery, useLazyFilesListNoAuthQuery, useLazyPrivateImageQuery } =
    fileApi;
